var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 672 670",
    width: 672,
    height: 670,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 44.5,
    y1: 251.3,
    x2: 44.5,
    y2: 153.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f48322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f89b41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 43.6,
    y1: 280.5,
    x2: 43.6,
    y2: 209,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ee3966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef567b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 751.6,
    y1: 78.7,
    x2: 542.9,
    y2: 180,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9a44e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fab46a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 541.6,
    y1: 140.3,
    x2: 529.2,
    y2: 230.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ee3966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef567b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5",
    x1: 160.6,
    y1: 685.1,
    x2: 108.9,
    y2: 514.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f48322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9ab5d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g6",
    x1: 128.6,
    y1: 622,
    x2: 205.5,
    y2: 408.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ee3966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef567b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7",
    x1: 615.2,
    y1: 401.1,
    x2: 671.3,
    y2: 401.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ee3966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef567b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g8",
    x1: 391.9,
    y1: 575.2,
    x2: 448,
    y2: 575.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ee3966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef567b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g9",
    x1: 448,
    y1: 466.6,
    x2: 504.1,
    y2: 466.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f48322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9ab5d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g10",
    x1: 503,
    y1: 489.9,
    x2: 559.1,
    y2: 489.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ec6cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90d4d6"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#8140ff}.b{fill:#a242e5}.c{fill:#a68efe}.d{fill:#00c2b3}.e{fill:#4cf2e9}.f{fill:#50e0d5}.g{fill:#db7212}.h{fill:#ffa64d}.i{fill:url(#g1)}.j{fill:#c62658}.k{fill:#ff6485}.l{fill:url(#g2)}.m{fill:#8a39d8}.n{fill:#ff8415}.o{fill:url(#g3)}.p{fill:url(#g4)}.q{fill:#6329a8}.r{fill:url(#g5)}.s{fill:url(#g6)}.t{fill:url(#g7)}.u{fill:#fc4f77}.v{fill:#fa3d69}.w{opacity:.8;mix-blend-mode:screen;fill:#ff6485}.x{fill:url(#g8)}.y{fill:url(#g9)}.z{fill:#ffae5d}.A{fill:url(#g10)}.B{fill:#78f2e9}.C{fill:#a650ea}.D{fill:#ff9430}.E{opacity:.8;mix-blend-mode:screen;fill:#ff9b3d}.F{fill:#4fefe7}.G{fill:#1dd8cf}.H{opacity:.8;mix-blend-mode:screen;fill:#78f2e9}.I{fill:#973edf}.J{fill:#8c3ad9}.K{opacity:.8;mix-blend-mode:screen;fill:#923cdd}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m273.2 199.3l-33.6-19.5-0.4-159 33.5 19.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m272.7 40.3l-33.5-19.5 34.6-20 33.5 19.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m307.3 20.3l0.5 159.1-34.6 19.9-0.5-159z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m221.3 229.3l-33.6-19.5-0.3-119.3 33.6 19.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m221 110l-33.6-19.5 34.6-20 33.6 19.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m255.6 90.1l0.3 119.2-34.6 20-0.3-119.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m169.4 259.3l-33.6-19.5-0.2-79.6 33.6 19.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m169.2 179.7l-33.6-19.5 34.6-19.9 33.6 19.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m203.8 159.8l0.2 79.5-34.6 20-0.2-79.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m117.5 289.2l-33.6-19.5-0.1-59.6 33.5 19.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m117.3 229.6l-33.5-19.5 34.6-20 33.5 19.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m151.9 209.6l0.2 59.6-34.6 20-0.2-59.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m619.8 80.2l-0.1 49.5-88.1 51.2v-49.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m531.6 131.5v49.4l-125-2.7v-49.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m619.8 80.2l-88.2 51.3-125-2.8c1.1-17.6 13.2-35 36.3-48.5 48.7-28.3 127.9-28.3 176.9 0z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m656.7 87.9l-0.1 93.4c0 18.4-12.1 36.8-36.3 50.9l0.1-93.4c24.2-14.1 36.3-32.5 36.3-50.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m620.4 138.8l-0.1 93.4-88.7-51.3v-93.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m619.8 36.7c49 28.3 49.3 74.1 0.6 102.4l-88.8-51.2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m406.5 180.6l0.1-25.9c-0.1 18.7 12.2 37.4 36.9 51.6 49 28.3 128.2 28.3 176.9 0l-0.1 25.9c-48.7 28.2-127.9 28.2-176.9 0-24.6-14.3-37-33-36.9-51.6z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m620.4 206.3c-48.7 28.3-127.9 28.3-176.9 0-25.7-14.8-38-34.5-36.9-54l125 2.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m167.9 453.5l-20.1-11.7 31.7-62.6 20.1 11.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m102.9 497.8l-20.1-11.7 34.8-68.8 20.1 11.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m54.1 546.4l-20.2-11.7 31.7-62.5 20.1 11.7z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m19.8 590.6l-20.2-11.7 25.8-51 20.2 11.7z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m199.6 390.9l69.1 55.9-63.6 36.8-69.9 40.3-4.1 2.4-59.5 34.3-0.7 0.4-34.3 19.8-16.8 9.8 25.8-51 8.5 6.8 31.6-62.5 17.2 13.9 34.8-68.7 30.2 24.4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m207.5 485.8l-20.1-11.7 30.9-61 20.1 11.7z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m138.5 518.1l-20.1-11.7 31.6-62.5 20.2 11.7z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m92.8 569.3l-20.1-11.7 31.7-62.6 20.1 11.7z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m58.6 613.4l-20.2-11.7 25.8-51 20.2 11.7z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m170.2 455.6l37.3 30.2 30.9-61 61.2 49.5-62.1 35.8-59.7 34.5-3.8 2.2-63.6 36.7-7 4.1-28 16.1-16.8 9.7 25.8-51 8.4 6.9 31.7-62.6 14 11.4z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m252.6 499.3l-20.1-11.7 30.2-59.7 20.2 11.7z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m188.2 536.2l-20.2-11.7 32-63.2 20.1 11.7z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m147.9 575.8l-20.1-11.7 25.9-51.2 20.1 11.7z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m99 636.4l-20.2-11.7 36-71.1 20.2 11.7z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m220.1 473l32.5 26.3 30.3-59.7 65.3 52.9-60.7 35.1-64.2 37-5.3 3.1-46.8 27-17.9 10.3-28.6 16.5-25.7 14.9 36-71.1 12.9 10.5 25.9-51.2 14.4 11.6z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m281.7 548.9l-20.2-11.7 44.9-88.7 20.2 11.7z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m246.6 568.8l-20.1-11.7 17.3-34.2 20.2 11.7z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m178.1 623.1l-20.2-11.7 39.5-77.9 20.1 11.7z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m138.5 659.5l-20.1-11.7 24.5-48.5 20.2 11.7z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m326.6 460.2l65.3 53-90.1 52-34.8 20.1-5.3 3-35.3 20.4-38.6 22.3-19.4 11.2-29.9 17.3 24.6-48.5 15 12.1 39.4-77.9 29.1 23.6 17.4-34.2 17.7 14.3z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m671.3 401.3l-0.2 123.2c-0.1 4.1-2.8 8.2-8.2 11.4-10.8 6.3-28.5 6.3-39.5 0-5.5-3.2-8.2-7.4-8.2-11.5l0.2-123.3c0 4.2 2.7 8.4 8.3 11.6 10.9 6.3 28.6 6.3 39.5-0.1 5.4-3.1 8.1-7.2 8.1-11.3z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m663 389.8c11 6.3 11 16.5 0.2 22.8-10.9 6.4-28.6 6.4-39.5 0.1-11-6.4-11.1-16.6-0.2-22.9 10.9-6.4 28.6-6.4 39.5 0z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m662.9 453.7c10.9 6.3 11 16.6 0.1 22.9-10.9 6.3-28.6 6.3-39.5 0-11-6.3-11-16.6-0.1-22.9 10.8-6.3 28.5-6.3 39.5 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      mixBlendMode: "multiply"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "m662.9 513c10.9 6.3 11 16.6 0.1 22.9-10.9 6.3-28.6 6.3-39.5 0-11-6.3-11-16.6-0.1-22.9 10.8-6.3 28.5-6.3 39.5 0z"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m671.2 464.4h-0.1c0 4.1-2.7 8.2-8.1 11.4-10.9 6.3-28.6 6.3-39.5 0-5.5-3.1-8.3-7.3-8.3-11.4v60c0.1 4.2 2.8 8.3 8.3 11.5 10.9 6.3 28.6 6.3 39.5 0 5.4-3.2 8.1-7.3 8.1-11.5h0.1z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m448 575.3l-0.2 77.9c0 4.1-2.7 8.3-8.1 11.4-10.9 6.3-28.6 6.3-39.5 0-5.5-3.2-8.3-7.3-8.3-11.5l0.3-77.9c-0.1 4.1 2.7 8.3 8.2 11.5 10.9 6.3 28.6 6.3 39.5 0 5.4-3.2 8.1-7.3 8.1-11.4z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m439.8 563.8c10.9 6.3 11 16.6 0.1 22.9-10.9 6.3-28.6 6.3-39.5 0-10.9-6.3-11-16.6-0.1-22.9 10.9-6.3 28.5-6.3 39.5 0z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m504.1 466.8l-0.2 153.3c0 4.1-2.7 8.2-8.1 11.3-10.9 6.4-28.6 6.4-39.5 0-5.5-3.1-8.3-7.3-8.3-11.5l0.3-153.3c-0.1 4.2 2.7 8.4 8.2 11.6 10.9 6.3 28.6 6.3 39.5 0 5.4-3.2 8.1-7.3 8.1-11.4z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "m495.9 455.3c10.9 6.3 11 16.5 0.1 22.9-10.9 6.3-28.6 6.3-39.5 0-10.9-6.4-11-16.6-0.1-22.9 10.9-6.3 28.5-6.3 39.5 0z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m559.1 490.1l-0.2 100.6c0 4.1-2.7 8.3-8.1 11.4-10.9 6.3-28.6 6.3-39.5 0-5.6-3.2-8.3-7.4-8.3-11.5l0.2-100.7c0 4.2 2.8 8.4 8.3 11.5 10.9 6.4 28.6 6.4 39.5 0 5.4-3.1 8.1-7.2 8.1-11.3z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m550.9 478.6c10.9 6.3 11 16.5 0.1 22.8-10.9 6.4-28.6 6.4-39.5 0-11-6.3-11-16.5-0.2-22.8 10.9-6.4 28.6-6.4 39.6 0z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m615.2 384.9l-0.2 173.1c-0.1 4.1-2.8 8.2-8.2 11.4-10.8 6.3-28.5 6.3-39.5 0-5.5-3.2-8.2-7.4-8.2-11.6l0.2-173.1c0 4.2 2.7 8.4 8.3 11.5 10.9 6.4 28.6 6.4 39.5 0 5.4-3.1 8.1-7.2 8.1-11.3z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m606.9 373.4c11 6.3 11 16.5 0.2 22.8-10.9 6.4-28.6 6.4-39.5 0-11-6.3-11.1-16.5-0.2-22.8 10.9-6.4 28.6-6.4 39.5 0z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m439.7 607.1c10.9 6.3 11 16.6 0.1 22.9-10.9 6.3-28.6 6.3-39.5 0-11-6.3-11-16.6-0.1-22.9 10.8-6.3 28.5-6.3 39.5 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      mixBlendMode: "multiply"
    }
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m439.7 642.4c10.9 6.3 11 16.6 0.1 22.9-10.9 6.3-28.6 6.3-39.5 0-11-6.3-11-16.6-0.1-22.9 10.8-6.3 28.5-6.3 39.5 0z"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m448 617.7h-0.1c0 4.2-2.7 8.3-8.1 11.5-10.9 6.3-28.6 6.3-39.5 0-5.5-3.2-8.2-7.3-8.3-11.5v36.1c0.1 4.2 2.8 8.3 8.3 11.5 10.9 6.3 28.6 6.3 39.5 0 5.4-3.2 8.1-7.3 8.1-11.5h0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "m494.8 533.5c10.7 6.2 10.8 16.2 0.1 22.4-10.6 6.2-28 6.2-38.7 0-10.8-6.2-10.8-16.2-0.1-22.4 10.6-6.2 28-6.2 38.7 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      mixBlendMode: "multiply"
    }
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m495.3 609.1c10.8 6.2 10.8 16.2 0.2 22.4-10.7 6.2-28.1 6.2-38.8 0-10.7-6.2-10.8-16.2-0.1-22.4 10.7-6.2 28-6.2 38.7 0z"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "E",
    d: "m503 543.9h-0.1c0 4.1-2.6 8.1-8 11.2-10.6 6.2-28 6.2-38.7 0-5.4-3.1-8.1-7.1-8.1-11.2l0.5 76.4c0 4.1 2.7 8.1 8.1 11.2 10.7 6.2 28.1 6.2 38.8 0 5.3-3.1 8-7.1 7.9-11.2h0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "F",
    d: "m550.7 535.5c10.9 6.4 11 16.6 0.1 22.9-10.9 6.3-28.6 6.3-39.5 0-10.9-6.3-11-16.5-0.1-22.9 10.9-6.3 28.6-6.3 39.5 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      mixBlendMode: "multiply"
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "G",
    d: "m550.7 579.2c10.9 6.3 11 16.6 0.1 22.9-10.9 6.3-28.6 6.3-39.5 0-10.9-6.3-11-16.6-0.1-22.9 10.9-6.3 28.6-6.3 39.5 0z"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "H",
    d: "m559.1 546.2h-0.2c0.1 4.1-2.6 8.3-8.1 11.4-10.9 6.3-28.6 6.3-39.5 0-5.5-3.1-8.2-7.3-8.2-11.4v44.4c0 4.2 2.7 8.3 8.2 11.5 10.9 6.3 28.6 6.3 39.5 0 5.5-3.2 8.2-7.3 8.1-11.5h0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "I",
    d: "m606.8 463.2c10.9 6.3 11 16.5 0.1 22.9-10.9 6.3-28.6 6.3-39.5 0-11-6.4-11-16.6-0.1-22.9 10.8-6.3 28.5-6.3 39.5 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      mixBlendMode: "multiply"
    }
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m606.8 546.5c10.9 6.3 11 16.5 0.1 22.9-10.9 6.3-28.6 6.3-39.5 0-11-6.4-11-16.6-0.1-22.9 10.8-6.4 28.5-6.4 39.5 0z"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "K",
    d: "m615.1 473.8h-0.1c0 4.1-2.7 8.3-8.1 11.5-10.9 6.3-28.6 6.3-39.5 0-5.5-3.2-8.3-7.3-8.3-11.5v84.1c0.1 4.2 2.8 8.3 8.3 11.5 10.9 6.3 28.6 6.3 39.5 0 5.4-3.2 8.1-7.4 8.1-11.5h0.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.59e1cd74e22e6b37fd9a20e02237ce7a.svg";
export { ForwardRef as ReactComponent };